import React, { createContext } from 'react';
import axios from '../../../../utils/axios';

import {
    defaultState,
    loadData
} from "../../../../contexts/BaseItemsContext";
import { cWarn } from '../../CustomLogger';

export const SchoolRulesContext = createContext();

class SchoolRulesContextProvider extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            testingRule:false,
            testRunning:false,
            showTestDialogue:false,
            showTestTemplateDialogue:false,
            testTemplateLoading:true,
            testFailed:false,
            testLogOutput:[],
            ...defaultState
        }

        this.unitPath = '/schoolrules/';
    }

    componentDidMount() {
        loadData(this);
    }

    setRuleActive(id){
        const apiPath = `${process.env.REACT_APP_API_URL}${this.unitPath}setruleactive/${id}`;
        axios.post(apiPath,{
            ruleId:id
        },{
            timeout: 30000,
            withCredentials:true
        }).then(() => {
           
            loadData(this);
        }).catch(err => {
           cWarn(err);
        });
    }

    setRuleInactive(id){
        const apiPath = `${process.env.REACT_APP_API_URL}${this.unitPath}setruleinactive/${id}`;
        axios.post(apiPath,{
            ruleId:id
        },{
            timeout: 30000,
            withCredentials:true
        }).then(() => {
            loadData(this);
        }).catch(err => {
           cWarn(err);
        });
    }

    closeTestDialog(){
        this.setState({
            showTestDialogue:false,
        })
    }

    closeTestTemplateDialogue(){
        this.setState({
            testRunning:false,
            showTestTemplateDialogue:false,
            testTemplateLoading:false
        })
    }

    testRuleTemplate(id){
        
        let testRuleName = '';
        for(let i=0; i<this.state.results.length; i+=1){
            if(id === this.state.results[i].id){
                testRuleName = this.state.results[i].name;
                break;
            }
            
        }

        
        this.setState({
            showTestTemplateDialogue:true,
            testTemplateLoading:true,
            testRuleName
        })
        const apiPath = `${process.env.REACT_APP_API_URL}${this.unitPath}testruletemplate/${id}`;
        axios.post(apiPath,{
            ruleId:id
        },{
            timeout: 30000,
            withCredentials:true
        }).then(res => {
            
            const {
                data:{
                    body:testEmailBody,
                    subject:testEmailSubject,
                    errors:testEmailErrors
                }
            } = res;
            
            this.setState({
                testTemplateLoading:false,
                testRuleId:id,
                testEmailBody,
                testEmailSubject,
                testEmailErrors
            })
        }).catch(err => {
           cWarn(err);
        });
    }

    testRule(id){
        const apiPath = `${process.env.REACT_APP_API_URL}${this.unitPath}testrule/${id}`;
        this.setState({
            testRunning:true,
            showTestDialogue:true,
            testFailed:false,
            testLogOutput:[]
        })
        axios.post(apiPath,{
            ruleId:id
        },{
            timeout: 30000,
            withCredentials:true
        }).then(res => {
            
            
            this.setState({
                testRunning:false,
                testLogOutput:res.data.log,
            })
        }).catch(() => {
            this.setState({
                testRunning:false,
                testFailed:true
            })
        });
    }


    grabPlaceholders(id){
        const apiPath = `${process.env.REACT_APP_API_URL}${this.unitPath}grabplaceholders/${id}`;
        
        axios.post(apiPath,{
            ruleId:id
        },{
            timeout: 30000,
            withCredentials:true
        }).then(res => {
            const jsonString = JSON.stringify(res.data,null,4);
            const blob = new Blob([jsonString], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
      
            const link = document.createElement('a');
            link.href = url;
            link.download = 'placholders.json';
            link.click();
            URL.revokeObjectURL(url)
        }).catch(() => {
           // console.log('the placholder rgab failed')
        });
    }


    render() {
        return (
            <SchoolRulesContext.Provider value={{
                ...this.state,
                unitPath:this.unitPath,
                setRuleActive:this.setRuleActive.bind(this),
                setRuleInactive:this.setRuleInactive.bind(this),
                testRule:this.testRule.bind(this),
                setState:this.setState.bind(this),
                closeTestDialog:this.closeTestDialog.bind(this),
                grabPlaceholders:this.grabPlaceholders.bind(this),
                closeTestTemplateDialogue:this.closeTestTemplateDialogue.bind(this),
                testRuleTemplate:this.testRuleTemplate.bind(this)
                }}>
                {this.props.children}
            </SchoolRulesContext.Provider>
        );
    }

}
export default SchoolRulesContextProvider;

